import React from "react";
import { Link } from "react-router-dom";
import "../styling/navbar.css";
import backgroundImg from "../asset/nav.png"; // or whatever image you want as background

function Navbar() {
  return (
    <nav
      className="navbar"
      style={{ backgroundImage: `url(${backgroundImg})` }}
    >
      
        <div className="navbar-content">
          <div className="navbar-logo">
            <span className="navbar-title">Sue Morris</span>
          </div>

          <ul className="navbar-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/journey">Journey</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
    
    </nav>
  );
}

export default Navbar;

